export enum DigitizationStep {
  UPLOAD_FORMS,
  IN_PROGRESS,
  COMPLETED,
}
